/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { AccessListsDetailsResponse } from '../model/access-lists-details-response';
// @ts-ignore
import { CreateCustomAccessListRequest } from '../model/create-custom-access-list-request';
// @ts-ignore
import { CustomAccessListResponse } from '../model/custom-access-list-response';
// @ts-ignore
import { GenericRequestResponse } from '../model/generic-request-response';
// @ts-ignore
// @ts-ignore
import { UpdateAccessListConfigurationRequest } from '../model/update-access-list-configuration-request';
// @ts-ignore
import { UpdateAccessListConfigurationResponse } from '../model/update-access-list-configuration-response';
// @ts-ignore
import { UpdateCustomAccessListRequest } from '../model/update-custom-access-list-request';

// @ts-ignore
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';

export interface CreateCustomAccessListRequestParams {
  /** The ID of the Shield Zone to which the Custom Access List will be associated. */
  shieldZoneId: number;
  createCustomAccessListRequest: CreateCustomAccessListRequest;
}

export interface DeleteCustomAccessListRequestParams {
  /** The ID of the Custom Access List to delete. */
  id: number;
  /** The ID of the Shield Zone to which the Custom Access List belongs. */
  shieldZoneId: number;
}

export interface GetAccessListEnumsRequestParams {
  shieldZoneId: string;
}

export interface GetAccessListsRequestParams {
  /** The ID of the Shield Zone to which the Access Lists belong. */
  shieldZoneId: number;
}

export interface GetCustomAccessListRequestParams {
  /** The ID of the Custom Access List to retrieve. */
  id: number;
  /** The ID of the Shield Zone to which the Custom Access List belongs. */
  shieldZoneId: number;
}

export interface UpdateAccessListConfigurationRequestParams {
  /** The ID of the Access List Configuration to update. */
  id: number;
  /** The ID of the Shield Zone to which the Access List Configuration belongs. */
  shieldZoneId: number;
  updateAccessListConfigurationRequest: UpdateAccessListConfigurationRequest;
}

export interface UpdateCustomAccessListRequestParams {
  /** The ID of the Custom Access List to update. */
  id: number;
  /** The ID of the Shield Zone to which the Custom Access List belongs. */
  shieldZoneId: number;
  updateCustomAccessListRequest: UpdateCustomAccessListRequest;
}

@Injectable({
  providedIn: 'root',
})
export class AccessListsService {
  protected basePath = 'https://api.bunny.net';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach((k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)));
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Create a new Custom Access List associated with a Shield Zone
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createCustomAccessList(
    requestParameters?: CreateCustomAccessListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<CustomAccessListResponse>;
  public createCustomAccessList(
    requestParameters?: CreateCustomAccessListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<CustomAccessListResponse>>;
  public createCustomAccessList(
    requestParameters?: CreateCustomAccessListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<CustomAccessListResponse>>;
  public createCustomAccessList(
    requestParameters?: CreateCustomAccessListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const shieldZoneId = requestParameters?.shieldZoneId;
    if (shieldZoneId === null || shieldZoneId === undefined) {
      throw new Error('Required parameter shieldZoneId was null or undefined when calling createCustomAccessList.');
    }
    const createCustomAccessListRequest = requestParameters?.createCustomAccessListRequest;
    if (createCustomAccessListRequest === null || createCustomAccessListRequest === undefined) {
      throw new Error('Required parameter createCustomAccessListRequest was null or undefined when calling createCustomAccessList.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/shield/shield-zone/${this.configuration.encodeParam({ name: 'shieldZoneId', value: shieldZoneId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}/access-lists`;
    return this.httpClient.request<CustomAccessListResponse>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createCustomAccessListRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Delete the specified Custom Access List associated with a Shield Zone
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCustomAccessList(
    requestParameters?: DeleteCustomAccessListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<GenericRequestResponse>;
  public deleteCustomAccessList(
    requestParameters?: DeleteCustomAccessListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<GenericRequestResponse>>;
  public deleteCustomAccessList(
    requestParameters?: DeleteCustomAccessListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<GenericRequestResponse>>;
  public deleteCustomAccessList(
    requestParameters?: DeleteCustomAccessListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteCustomAccessList.');
    }
    const shieldZoneId = requestParameters?.shieldZoneId;
    if (shieldZoneId === null || shieldZoneId === undefined) {
      throw new Error('Required parameter shieldZoneId was null or undefined when calling deleteCustomAccessList.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/shield/shield-zone/${this.configuration.encodeParam({ name: 'shieldZoneId', value: shieldZoneId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}/access-lists/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}`;
    return this.httpClient.request<GenericRequestResponse>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get all Access Lists API enumeration types and their values
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAccessListEnums(
    requestParameters?: GetAccessListEnumsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<{ [key: string]: { [key: string]: string } }>;
  public getAccessListEnums(
    requestParameters?: GetAccessListEnumsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<{ [key: string]: { [key: string]: string } }>>;
  public getAccessListEnums(
    requestParameters?: GetAccessListEnumsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<{ [key: string]: { [key: string]: string } }>>;
  public getAccessListEnums(
    requestParameters?: GetAccessListEnumsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const shieldZoneId = requestParameters?.shieldZoneId;
    if (shieldZoneId === null || shieldZoneId === undefined) {
      throw new Error('Required parameter shieldZoneId was null or undefined when calling getAccessListEnums.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/shield/shield-zone/${this.configuration.encodeParam({ name: 'shieldZoneId', value: shieldZoneId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/access-lists/enums`;
    return this.httpClient.request<{ [key: string]: { [key: string]: string } }>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get all Access Lists available for a Shield Zone
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAccessLists(
    requestParameters?: GetAccessListsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<AccessListsDetailsResponse>;
  public getAccessLists(
    requestParameters?: GetAccessListsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<AccessListsDetailsResponse>>;
  public getAccessLists(
    requestParameters?: GetAccessListsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<AccessListsDetailsResponse>>;
  public getAccessLists(
    requestParameters?: GetAccessListsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const shieldZoneId = requestParameters?.shieldZoneId;
    if (shieldZoneId === null || shieldZoneId === undefined) {
      throw new Error('Required parameter shieldZoneId was null or undefined when calling getAccessLists.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/shield/shield-zone/${this.configuration.encodeParam({ name: 'shieldZoneId', value: shieldZoneId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}/access-lists`;
    return this.httpClient.request<AccessListsDetailsResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get the specified Custom Access List associated with a Shield Zone
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCustomAccessList(
    requestParameters?: GetCustomAccessListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<CustomAccessListResponse>;
  public getCustomAccessList(
    requestParameters?: GetCustomAccessListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<CustomAccessListResponse>>;
  public getCustomAccessList(
    requestParameters?: GetCustomAccessListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<CustomAccessListResponse>>;
  public getCustomAccessList(
    requestParameters?: GetCustomAccessListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getCustomAccessList.');
    }
    const shieldZoneId = requestParameters?.shieldZoneId;
    if (shieldZoneId === null || shieldZoneId === undefined) {
      throw new Error('Required parameter shieldZoneId was null or undefined when calling getCustomAccessList.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/shield/shield-zone/${this.configuration.encodeParam({ name: 'shieldZoneId', value: shieldZoneId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}/access-lists/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}`;
    return this.httpClient.request<CustomAccessListResponse>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Update Access List Configuration for a Shield Zone
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateAccessListConfiguration(
    requestParameters?: UpdateAccessListConfigurationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<UpdateAccessListConfigurationResponse>;
  public updateAccessListConfiguration(
    requestParameters?: UpdateAccessListConfigurationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<UpdateAccessListConfigurationResponse>>;
  public updateAccessListConfiguration(
    requestParameters?: UpdateAccessListConfigurationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<UpdateAccessListConfigurationResponse>>;
  public updateAccessListConfiguration(
    requestParameters?: UpdateAccessListConfigurationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateAccessListConfiguration.');
    }
    const shieldZoneId = requestParameters?.shieldZoneId;
    if (shieldZoneId === null || shieldZoneId === undefined) {
      throw new Error('Required parameter shieldZoneId was null or undefined when calling updateAccessListConfiguration.');
    }
    const updateAccessListConfigurationRequest = requestParameters?.updateAccessListConfigurationRequest;
    if (updateAccessListConfigurationRequest === null || updateAccessListConfigurationRequest === undefined) {
      throw new Error('Required parameter updateAccessListConfigurationRequest was null or undefined when calling updateAccessListConfiguration.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/shield/shield-zone/${this.configuration.encodeParam({ name: 'shieldZoneId', value: shieldZoneId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}/access-lists/configurations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}`;
    return this.httpClient.request<UpdateAccessListConfigurationResponse>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updateAccessListConfigurationRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Update the specified Custom Access List associated with a Shield Zone
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateCustomAccessList(
    requestParameters?: UpdateCustomAccessListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<CustomAccessListResponse>;
  public updateCustomAccessList(
    requestParameters?: UpdateCustomAccessListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<CustomAccessListResponse>>;
  public updateCustomAccessList(
    requestParameters?: UpdateCustomAccessListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<CustomAccessListResponse>>;
  public updateCustomAccessList(
    requestParameters?: UpdateCustomAccessListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateCustomAccessList.');
    }
    const shieldZoneId = requestParameters?.shieldZoneId;
    if (shieldZoneId === null || shieldZoneId === undefined) {
      throw new Error('Required parameter shieldZoneId was null or undefined when calling updateCustomAccessList.');
    }
    const updateCustomAccessListRequest = requestParameters?.updateCustomAccessListRequest;
    if (updateCustomAccessListRequest === null || updateCustomAccessListRequest === undefined) {
      throw new Error('Required parameter updateCustomAccessListRequest was null or undefined when calling updateCustomAccessList.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/shield/shield-zone/${this.configuration.encodeParam({ name: 'shieldZoneId', value: shieldZoneId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}/access-lists/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int64' })}`;
    return this.httpClient.request<CustomAccessListResponse>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updateCustomAccessListRequest,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }
}
